<script setup>
import { useI18n } from 'vue-i18n';
import LaisModal from 'dashboard/components-next/LaisModal.vue';

defineProps({
  context: { type: Object, default: () => ({}) },
  show: { type: Boolean, default: false },
});

const emit = defineEmits(['close']);
const { t } = useI18n();
</script>

<template>
  <LaisModal
    :show="show"
    :title="t('SALES.DELIVERY.REVIEW_RECEIPT.MODAL.TITLE')"
    max-width-class="max-w-[760px]"
    @close="emit('close')"
  >
    <div class="grid gap-5">
      <header class="flex flex-wrap items-center justify-between gap-3">
        <h2 class="font-redHatDisplay text-xl font-bold text-lais-text">
          {{ t('SALES.DELIVERY.REVIEW_RECEIPT.MODAL.RECEIPT_TITLE') }}
        </h2>
        <span
          class="rounded-full px-2 py-1 text-xs font-bold uppercase"
          :class="
            context.isComplete
              ? 'bg-emerald-50 text-emerald-700'
              : 'bg-red-50 text-red-700'
          "
        >
          {{
            context.isComplete
              ? t('SALES.DELIVERY.REVIEW_RECEIPT.MODAL.COMPLETE')
              : t('SALES.DELIVERY.REVIEW_RECEIPT.MODAL.PENDING')
          }}
        </span>
      </header>

      <section class="grid gap-2">
        <h3
          class="text-xs font-bold uppercase tracking-wide text-lais-text-muted"
        >
          {{ t('SALES.DELIVERY.REVIEW_RECEIPT.MODAL.CHECKS') }}
        </h3>
        <ul
          class="grid gap-2 rounded-lais-sm bg-lais-bg-soft p-4 text-sm text-lais-text-body"
        >
          <li v-for="(check, index) in context.checks" :key="check.id || index">
            {{ check.name || check.nome || check }}
          </li>
          <li v-if="!context.checks?.length">
            {{ t('SALES.DELIVERY.REVIEW_RECEIPT.MODAL.EMPTY') }}
          </li>
        </ul>
      </section>

      <section class="grid gap-2">
        <h3
          class="text-xs font-bold uppercase tracking-wide text-lais-text-muted"
        >
          {{ t('SALES.DELIVERY.REVIEW_RECEIPT.MODAL.OBSERVATION') }}
        </h3>
        <p
          class="whitespace-pre-wrap rounded-lais-sm border border-lais-border-soft p-4 text-sm text-lais-text-body"
        >
          {{
            context.observation ||
            t('SALES.DELIVERY.REVIEW_RECEIPT.MODAL.EMPTY')
          }}
        </p>
      </section>
    </div>
  </LaisModal>
</template>
